import { apiGet, apiPost } from "./apiREST";

export type ReleaseNotesStatus = {
  current_version: string;
  user_has_acknowledged: boolean;
};

const RELEASE_NOTES_STATUS_URL = "release-notes/status/";
const RELEASE_NOTES_ACKNOWLEDGE_URL = "release-notes/acknowledge/";

export async function getReleaseNotesStatus(): Promise<{
  data: ReleaseNotesStatus | null;
  error: unknown;
}> {
  return apiGet(RELEASE_NOTES_STATUS_URL);
}

export async function acknowledgeReleaseNotes(version: string): Promise<{
  data: unknown;
  error: unknown;
}> {
  return apiPost(RELEASE_NOTES_ACKNOWLEDGE_URL, { version });
}
